/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     成员 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function getAllUser(params) {
  return request({
    url: "?c=sys&a=user&do=getall",
    method: "get",
    params
  });
}

export function getUserList(params) {
  return request({
    url: "?c=sys&a=user&do=list",
    method: "get",
    params
  });
}

export function createUserApi(formData) {
  return request({
    url: "?c=sys&a=user&do=create",
    method: "post",
    data: formData
  });
}

export function getAllRoleApi(params) {
  return request({
    url: "?c=sys&a=role&do=getall",
    method: "get",
    params
  });
}

export function delUserApi(formData) {
  return request({
    url: "?c=sys&a=user&do=del",
    method: "post",
    data: formData
  });
}

export function editUserApi(formData) {
  return request({
    url: "?c=sys&a=user&do=edit",
    method: "post",
    data: formData
  });
}

export function getUserDetailApi(params) {
  return request({
    url: "?c=sys&a=user&do=get",
    method: "get",
    params
  });
}

export function importUserApi(formData) {
  return request({
    url: "?c=sys&a=user&do=import",
    method: "post",
    data: formData
  });
}

export function exportUserApi(formData) {
  return request({
    url: "?c=sys&a=user&do=export",
    method: "post",
    data: formData
  });
}
